import { FC, lazy, TouchEventHandler, useEffect, useState } from "react";
import cn from "classnames";
import { BadgeInfo, CreditCard, UserRound } from "lucide-react";
import { FormattedMessage } from "react-intl";
import styles from "./styles.module.scss";
import { useStopScroll } from "@/common/hooks/useStopScroll";
import CrossIcon from "@/common/svg/cross-icon.svg";
import Logo from "@/common/svg/logo-neo-credit.svg";
import { WorkingTime } from "@/components/WorkingTime";
import { LangSwitcher } from "@/features/LangSwitcher";
import { Logout } from "@/features/Logout";
import { useLocationMatch } from "@/router/hooks/useLocationMatch";
import { IconButton } from "@/shared/ui/Buttons/IconButton";
import { CallCenter } from "@/shared/ui/CallCenter";
import { Licence } from "@/shared/ui/Licence";
import { ANIMATION_DURATION_STANDARD } from "@/styles/constantsJS";
import DrawerNavLink from "@/widgets/Drawer/ui/NavLink";

interface DrawerProps {
  toggle: boolean;
  toggleHandler: () => void;
}

const DRAWER_ID = "drawer";

const MediationLink = lazy(
  () => import("@/entities/mediation/ui/MediationDrawerLink"),
);

const Drawer: FC<DrawerProps> = ({ toggle, toggleHandler }) => {
  const token = localStorage.getItem("token");
  const { cabinetLocationMatch } = useLocationMatch();
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    if (toggle) {
      setTimeout(() => setIsVisible(true));
    }
  }, [toggle]);

  const closeHandler = () => {
    setIsVisible(false);
    setTimeout(() => toggleHandler(), ANIMATION_DURATION_STANDARD);
  };

  const handleOutClick: TouchEventHandler<HTMLElement> = (event) => {
    const target = event.target as HTMLElement;
    if (!target.closest(`#${DRAWER_ID}`)) {
      closeHandler();
    }
  };

  const onLinkClick = () => {
    closeHandler();
  };

  useStopScroll(isVisible);

  return (
    <aside
      onTouchEnd={handleOutClick}
      className={cn(styles.drawer, { [styles.visible]: isVisible })}
    >
      <div id={DRAWER_ID} className={styles.mobileMenu}>
        <div className={styles.header}>
          <LangSwitcher />
          <div className={styles.logo}>
            <Logo />
          </div>
          <IconButton
            id="drawer-close"
            Icon={CrossIcon}
            onClick={closeHandler}
          />
        </div>
        <div className={styles.body}>
          <div className={styles.main}>
            <nav className={styles.navWrapper}>
              <DrawerNavLink to="/payments-info" onClick={closeHandler}>
                <BadgeInfo />
                <FormattedMessage defaultMessage="Способы оплаты" />
              </DrawerNavLink>
              <DrawerNavLink to="/payment" onClick={closeHandler}>
                <CreditCard />
                <FormattedMessage defaultMessage="Внести оплату" />
              </DrawerNavLink>
              {/*{!!token && (*/}
              {/*  <Suspense fallback={null}>*/}
              {/*    <MediationLink closeHandler={closeHandler} />*/}
              {/*  </Suspense>*/}
              {/*)}*/}
              <DrawerNavLink
                to="/auth"
                active={cabinetLocationMatch}
                onClick={closeHandler}
              >
                <UserRound />
                <FormattedMessage defaultMessage="Личный кабинет" />
              </DrawerNavLink>
            </nav>
            <CallCenter />
          </div>
          <div className={styles.footer}>
            <Logout handler={onLinkClick} />
            <div className={styles.footerText}>
              <Licence />
              <WorkingTime />
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Drawer;
